import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { useLazyQuery } from '@grandvisionhq/graphql';
import { useIntl } from '@grandvisionhq/state';
import { GET_STORE_OFFER_BY_CODE } from '../../queries/get-store-offer-by-code.js';
import { fromStoreOfferQueryToStore } from './adapters/fromStoreOfferQueryToStore.js';

const useStoreOfferByCode = (variables)=>{
    const { locale  } = useIntl();
    const [query, queryState] = useLazyQuery(GET_STORE_OFFER_BY_CODE, {
        variables,
        context: {
            forwardHeaders: {
                'Accept-Language': locale
            }
        }
    });
    const data = React.useMemo(()=>{
        var ref;
        return ((ref = queryState.data) === null || ref === void 0 ? void 0 : ref.store) ? fromStoreOfferQueryToStore(queryState.data.store) : null;
    }, [
        queryState
    ]);
    return React.useMemo(()=>[
            query,
            swcHelpers.objectSpread({}, queryState, {
                data
            }), 
        ]
    , [
        data,
        queryState,
        query
    ]);
};
var useStoreOfferByCode$1 = useStoreOfferByCode;

export { useStoreOfferByCode$1 as default };
//# sourceMappingURL=use-store-offer-by-code.js.map
